export default {
  /** @name Store */
  store: { type: Object },
  /** @name 表单数据 */
  formData: { type: Object },
  /** @name 表格数据 */
  dataSource: {
    type: Array,
    default() {
      return []
    },
  },
  /** @name 验收结论的默认值 */
  acceptResultDefault: {
    type: Object,
    default: () => ({
      id: '339f97fd-1da7-42b8-9947-9e776bffa24c',
      code: 'ACCEPT_RESULT_30',
      name: '合格',
    }),
  },
  /** @name 获取商品失败的错误提示信息 */
  queryGoodsErrorMessage: {
    type: String,
    default: '系统找不到对应的商品档案',
  },
  // 可展示的解析结果字段名集
  analysisMessagesOptions: {
    type: Array,
    default() {
      return [
        'productIdent',
        'batchNumber',
        'periodBegin',
        'periodEnd',
        'periodExpire',
        'serialNumber',
        'amount',
      ]
    },
  },
  /** @name 禁止通过epc查询商品档案或库存，根据场景不同设置 */
  disabledEpcQuery: {
    type: Boolean,
    default: false,
  },
  /** @name 确认提交时，是否禁止清空扫码区域表单 */
  disabledClearForSubmit: {
    type: Boolean,
    default: false,
  },
  /**
   * @name 外部出入的错误提示信息
   * 数据结构:
   * {
   *   type: 'error' | 'warn',
   *   message: ''
   * }
   */
  errorMessage: {
    type: Object,
  },
  /** @name 是否反算日期 */
  isCalcDate: {
    type: Boolean,
    default: true,
  },
  /** @name 识别失败的错误提示信息 */
  analysisErrorMessage: {
    type: String,
    default: '系统无法识别此类信息',
  },
  // 有参照报错的提示信息
  referErrorMessage: {
    type: String,
    default: '此商品不在任务范围内',
  },
  // 已扫数量不正确的提示信息
  amountErrorMessage: {
    type: String,
    default: '累计扫码数量已经超出了待处理数量，请仔细检查！',
  },
  // 未匹配到数据
  nodataErrorMessage: {
    type: String,
    default: '未匹配到数据，或任务已完成',
  },
  // 没有查询到货位的提示信息
  locationErrorMessage: {
    type: String,
    default: '没有查询到货位',
  },
  /** @name 已超出库存数据范围 */
  availableErrorMessage: {
    type: String,
    default: '操作失败，超出库存数据范围',
  },
  /** @name 未开启序列号管理的错误提示信息 */
  serialErrorMessage: {
    type: String,
    default: '该商品未启用序列号管理',
  },
  /** @name 未包含全球唯一标识的错误提示信息 */
  gtinErrorMessage: {
    type: String,
    default: '请先扫描全球唯一标识',
  },
  // 是否显示弹窗
  value: {
    type: Boolean,
    default: true,
  },
  // 弹窗宽度 或 Input 组件的输入框宽度
  width: {
    type: [String, Number],
    default: '100%',
  },
  // 左侧位置偏移量
  offset: {
    type: Number,
    default: 200,
  },
  // 标题
  title: {
    type: String,
    default: '开始扫码',
  },
  // 是否将弹层放置于 body 内
  transfer: {
    type: Boolean,
    default: true,
  },
  /** @name 扫码输入框（识别商品）的placeholder */
  placeholder: { type: String, default: '请先扫描能够识别商品的条码' },
  // 搜索输入框的 placeholder
  searchPlaceholder: {
    type: String,
    default: '搜索商品',
  },
  /** @name 自定义必填项校验的项 */
  checkArr: {
    type: Array,
    default() {
      // 参考：['batchNumber', 'periodBegin', 'periodEnd', 'registration', 'certification']
      return []
    },
  },
  /** @name 商品明细取值路径 */
  itemsKey: { type: String, default: 'items' },
  /** @name formData的取值路径 */
  formDataKey: { type: String, default: 'formData' },
  /**
   * @name 扫码区表单项
   * 数据结构:
   * {
   *    code: 'code',
   *    valueKey: 'code',
   *    name: '商品编号',
   *    visiable(可选): true(显示) | false(隐藏)，默认: 显示
   *    style(可选): {width: '125px'},
   *    component(可选): 'Input', 默认: Input
   *    parameter(可选): {
   *      urlQuery: '请求接口地址’,
   *      requestMethod: '请求方法 默认: get',
   *      valueKey(可选): 'value的key, 默认: value',
   *      labelKey(可选): 'label的key, 默认: label'
   *    },
   *    props(可选): {clearable: true}
   * }
   */
  diAreaColumns: {
    type: Array,
    default() {
      return []
    },
  },
  /** @name 查询库存的接口 */
  queryStockOfUrl: { type: String, default: '' },
  /** @name 查询库存的接口方法 */
  queryStockOfMethod: { type: String, default: 'post' },
  /** @name 查询库存的接口参数 */
  queryStockOfParams: { type: Object },
  /** @name 添加商品明细的接口 */
  createItemOfUrl: { type: String, default: '' },
  /** @name 查询库存的接口方法 */
  createItemOfMethod: { type: String, default: 'post' },
  /** @name 查询库存的接口参数 */
  createItemOfParams: { type: Object },
  /** @name 自定义事件名（用于配置在按钮上自定义组件） */
  eventName: { type: String, default: 'on-ok-and-continue' },
  /** @name 传递的额外参数，例如：传递给store */
  eventParams: { type: Object },
  /** @name 定义商品数据的属性名。默认:goodsDetail */
  dataGoodsInfoKey: {
    type: String,
    default: 'goodsDetail', // 可能值 goodsDetail / goodsInfo
  },
  /** @name 定义商品数据goodsKeeping的属性名。 */
  dataGoodsKeepingKey: {
    type: String,
    default: 'goodsKeeping', // 可能值 goodsKeeping / goodsStore
  },
  /** @name 定义商品数据preserve的属性名。 */
  dataGoodsPreserveKey: {
    type: String,
    default: 'preserve',
  },
  /** @name 定义返回数据中的已扫数量的属性名。用于确认提交时，验证已扫数量<=待处理数量 */
  dataAmountKey: {
    type: String,
    default: 'amount', // 可能的值 amount
  },
  /** @name 定义返回数据中的库存可供数量的属性名。用于校验库存数据范围 */
  dataAvailableKey: { type: String, default: 'available' },
  /** @name 定义返回数据中的待处理数量的属性名。用于确认提交时，验证已扫数量<=待处理数量 */
  dataPendingKey: {
    type: String,
    default: 'plan', // 可能的值 plan
  },
  /** @name 获取表格数据详细信息的接口地址 */
  tableDataInfoUrl: { type: String, default: '' },
  /** @name 获取表格数据详细信息的接口请求方法 */
  tableDataInfoMethod: { type: String },
  /** @name 获取表格数据详细信息的接口的传递参数 */
  tableDataInfoParameters: { type: Object },
  /** @name 获取保质期的接口地址 */
  validDateUrl: { type: String, default: 'rest/main/goods/goods/queryPeriod' },
  /** @name 保存接口地址 */
  saveUrl: { type: String, default: '' },
  /** @name 请求保存接口的参数 */
  saveParams: { type: Object },
  /** @name 扫码获取货位的数据 */
  locationScanInfoUrl: { type: String, default: 'rest/ezscc/scan/scanLocation' },
  /** @name 扫码获取货位的数据的接口参数 */
  locationScanInfoParams: { type: Object },
  /** @name 扫码获取推荐货位的接口 */
  locationScanInfoOfRecommend: { type: String, default: 'rest/ezscc/store/getRecommendLocation' },
  /** @name 扫码获取推荐货位的接口参数 */
  locationScanInfoOfRecommendParams: { type: Object },
  /** @name 是否禁止保存时真实保存 */
  disabledPureSave: { type: Boolean, default: false },
  /** @name 扫码结果暂存服务端的暂存接口地址 */
  pureSaveOfUrl: { type: String, default: 'rest/main/store/receipt/draft' },
  /** @name 表单项【效期】后面，是否显示，“无值”按钮 */
  showEmptyBtn: { type: Boolean, default: true },
  /** @name 是否可设置扫码商品属性 */
  isScanProperty: { type: Boolean, default: false },
  /** @name 组件setGoodOfScanProperty.vue的props，请参考它的Props设置 */
  scanPropertyProps: { type: Object },
  /** @name 组件identifySerialInBatchNumber.vue的props，请参考它的Props设置 */
  scanIdentifyProps: { type: Object },
  /** @name id前缀 */
  idPrefix: { type: String, default: 'idPrefix' },
  /** @name  配置此prop，则按钮【设置商品扫码属性】会校验用户是否有权限操作此按钮。注意！！！需要同步配置按钮SET_GOODS_PROPERTY，并且别名加上走权限 */
  buttonMenuListUrl: { type: String, default: '' },
  /** @name 配置请求buttonMenuListUrl的参数 */
  buttonMenuListParams: { type: Object },
  /** @name  配置此prop，则获取按钮【打印条码】 */
  buttonMenuListOfPrint: {
    type: Array,
    default() {
      return [
        {
          selected: false,
          checked: false,
          expand: false,
          disabled: false,
          id: '0516e4bd-4ff3-4d7f-8af8-415d02b40765',
          parent: '.',
          code: 'SCAN_PRINT',
          lead: '0',
          leaf: true,
          depth: 0,
          title: '打印条码',
          name_: null,
          name: '打印条码',
          displayName: null,
          children: [],
          type: 'component',
          icon: null,
          style: null,
          alias: 'PRINT',
          region: null,
          param: {
            component: 'selectTemplateModal',
          },
          requestParam: {
            remote: true,
            openUrl: 'static/views/batchPrint.html',
            batchData: 'SCAN_SUB',
            clearable: true,
            selectUrl: "rest/ezcomp/report/templateItems?catalog=SCAN_0001&targetId=‘.'",
            compileData: true,
            optionLabel: 'name',
            optionValue: 'url',
            batchPrintJs: 'decision/view/report?op=emb&resource=finereport.js',
            batchPrintCss: 'decision/view/report?op=emb&resource=finereport.css',
            requestMethod: 'get',
            templateTitle: '选择打印模板',
            batchPrintConf: {
              isPopUp: false,
              printType: 0,
            },
          },
          beforeAction: '',
          beforeProperty: {},
          beforeParameter: {},
          afterAction: '',
          afterProperty: {},
          afterParameter: {},
          property: {},
          parameter: {},
          component: null,
          execute: null,
          doing: {
            action: {
              code: 'component',
              name: '自定义组件',
            },
            property: {
              component: 'selectTemplateModal',
            },
            parameter: {
              remote: true,
              openUrl: 'static/views/batchPrint.html',
              batchData: 'SCAN_SUB',
              clearable: true,
              selectUrl: "rest/ezcomp/report/templateItems?catalog=SCAN_0001&targetId=‘.'",
              compileData: true,
              optionLabel: 'name',
              optionValue: 'url',
              batchPrintJs: 'decision/view/report?op=emb&resource=finereport.js',
              batchPrintCss: 'decision/view/report?op=emb&resource=finereport.css',
              requestMethod: 'get',
              templateTitle: '选择打印模板',
              batchPrintConf: {
                isPopUp: false,
                printType: 0,
              },
            },
          },
          after: {
            action: {
              code: '',
              name: null,
            },
            property: {},
            parameter: {},
          },
          before: {
            action: {
              code: '',
              name: null,
            },
            property: {},
            parameter: {},
          },
          enableExp: '',
          showExp: null,
        },
      ]
    },
  },
  /**
   * @name 设置商品扫码属性按钮的别名，会控制按钮是否显示（是否有操作权限）
   * @description 接口返回的 item.alias 和 props.setPropertyAlias 相等则具备操作权限，或者 item.alias 为空则不参与权限控制
   */
  setPropertyAlias: {
    type: String,
    default: 'GOODS_PROPERTY',
  },
  /**
   * @name 必填校验策略（数量、商品编码必校验）
   * @description 可选值: 校验商品档案中的必填字段='validSetting'
   */
  validStrategy: {
    type: Array,
    default() {
      return []
    },
  },
  /** @name 执行的模式（高级模式） */
  model: {
    type: String,
    default: '',
  },
  /** @name 是否隐藏自定义序列号添加 */
  visiableEpc: {
    type: Boolean,
    default: true,
  },
  /** @name 扩展参数,json格式或者对象 */
  extendRequestParam: {
    type: [Object],
    default: () => ({}),
  },
  /** @name 关闭自动开启序列号管理 */
  disableAutoSerial: {
    type: Boolean,
    default: false,
  },
  /** @name 是否禁止选择库存（#6567） */
  disabledSelectStock: {
    type: Boolean,
    default: false,
  },
  /** @name 直接出库参数-如果有值则代表是直接出库模式（#7369） */
  directOutStorageModeParams: {
    type: Object,
  },
  /** @name 是否开启批量扫码模式 */
  openScanMultiple: {
    type: Boolean,
    default: false,
  },
  /** @name 是否开启锁定商品 */
  openLockGoods: {
    type: Boolean,
    default: false,
  },
}
